import React from 'react'
import "./productAnsclientId.scss"
import Dropzone from 'react-dropzone';
import { MdOutlineFileUpload } from "react-icons/md";
import StepButton from '../../common/StepButton';
import { ReactComponent as BackArrow } from "../../../images/back_arrow.svg"
import { FaRegFilePdf } from "react-icons/fa6";
import CustomeHeading from '../../customeHeading/customeHeading';
import { toast } from 'react-toastify';

const ProductAnsClientId = ({
  handleBack,
  setClientIdFile,
  clientIdFile,
  setSendClientId,
  sendClientId,
  submitClientDoc,
  docError,
  loading
}) => {

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const docFile = acceptedFiles[0];
      if (docFile) {
        setSendClientId(docFile)
        setClientIdFile(URL.createObjectURL(docFile))
      }
    }

  }
  const openDoc = () => {
    window.open(clientIdFile)
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
    return null; // Return null if the cookie is not found
  }

  // Usage
  const facesAccessToken = getCookie('faces_access_token');



  return (
    <div className='productAnsIdMain'>
     <div className='backArrowWrapper'>
            <BackArrow onClick={()=>handleBack()} />
          </div>
        <div className='maxWidth540 paddintTop80'>
              <CustomeHeading 
                Title="Client id"
                Desc="The Client ID helps match your responses with the pharmacy's records for accurate processing."
              />
            <div className='productAnsIdSection'>
                {/* <div className='questionHeader'>
                    <span className='question'>
                     
                    </span>
                    <span className='queText'>
                    
                    </span>
                </div> */}

          <div className='chooseFileCont'>
            <div className='inputFileDiv'>
              <Dropzone
                accept={{ 'application/pdf': ['.pdf'], 'image/png': ['.png'], 'image/jpeg': ['.jpeg'], 'image/jpg': ['.jpg'] }}
                onDrop={
                  (acceptedFiles) => {
                                                      if (acceptedFiles[0].size >  10 * 1024 * 1024) {
                                                        toast.error("Image  exceeds the 10 MB limit.")
                                                      } else {
                                                      onDrop(acceptedFiles)
                                                      }
                                                    }
                  // onDrop
                
                }
              >
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps({ className: "dropzone" })}>
                    <label className='label' onClick={(e) => e.stopPropagation()}>
                      <input {...getInputProps()}  />
                      {
                        clientIdFile || sendClientId ?
                          (
                            clientIdFile?.includes('.pdf') || sendClientId?.path?.includes('.pdf') ?
                              (
                                <FaRegFilePdf className='uploadedPdf' onClick={() => openDoc()} />
                              ) :
                              <img
                                src={clientIdFile}
                                className='uploadedImg'
                              />
                          )
                          :
                          <span className={`label`} >
                            <MdOutlineFileUpload className='uploadImg' />
                            <span className='imgText'>Upload file</span>
                            <p className="doc-type-text">JPG, PNG and PDF supported.</p>
                          </span>
                      }

                    </label>
                  </div>
                )}
              </Dropzone>

            </div>
          </div>
          <span className='answerError'>{docError}</span>

                <div className='submitBtn'>
                   <StepButton 
                      label={"Submit"}
                      blue={true}
                      className={"submitbtn"}
                      onClick={() => {
                        submitClientDoc();
                      }}
                      isLoading={loading}
                    />
                </div>

        </div>
      </div>
    </div>
  )
}

export default ProductAnsClientId